import { MutableRefObject, useEffect, useRef, useState } from "react";

export const useHasMounted = (): boolean => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
};

export const useTimeout = (callback: () => void, delay: number): void => {
  // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065 for typing
  const savedCallback: MutableRefObject<typeof callback | null> =
    useRef<typeof callback>(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (savedCallback.current == null) {
        return;
      }
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setTimeout(tick, delay);
      return () => clearTimeout(id);
    }
  }, [delay]);
};
